export default {
  outOfStockTitle: {
    id: 'product_machina_out_of_stock_title',
    defaultMessage: '😰 This model is popular!',
  },
}
